import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SVGIcon from '../../SVGIcon';
import { StyledOpenButtonWrapper, StyledButtonText, StyledSVGIcon, StyledSpinner } from './TextLink.styles';

class TextLink extends Component {
  static propTypes = {
    /** Text to display in the link */
    children: PropTypes.node,
    /** Text color */
    color: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'quaternary', 'error']),
    /** SVGIcon component to override the default */
    icon: PropTypes.node,
    /** Places icon either before or after text */
    iconPlacement: PropTypes.oneOf(['before', 'after']),
    /** function onClick */
    onClick: PropTypes.func,
    /** adds border above */
    hasBorder: PropTypes.bool,
    /** Hides the icon and only shows on hover */
    showIconOnHover: PropTypes.bool,
    /** Removes default margins */
    noMargins: PropTypes.bool,
    /** Classname for styling purposes */
    className: PropTypes.string,
    /** Boolean to toggle loading state */
    loading: PropTypes.bool,
    /** Boolean to toggle disabled state */
    disabled: PropTypes.bool,
    /** Changes pointer without affecting opacity */
    pointer: PropTypes.bool,
    /** Makes the button full width */
    fullWidth: PropTypes.bool
  };

  static defaultProps = {
    children: 'Open',
    color: 'quaternary',
    icon: <SVGIcon selectedIcon="openPanel" />,
    iconPlacement: 'before',
    pointer: true,
    onClick: () => {},
    hasBorder: false,
    showIconOnHover: false,
    noMargins: false,
    className: '',
    loading: false,
    disabled: false,
    fullWidth: false
  };

  constructor(props) {
    super(props);
    const { showIconOnHover } = this.props;
    this.state = { showIcon: !showIconOnHover };
  }

  hoverHandler = () => {
    const { showIconOnHover } = this.props;
    const { showIcon } = this.state;

    if (showIconOnHover) {
      this.setState({ showIcon: !showIcon });
    }
  };

  render() {
    const {
      children,
      color,
      icon,
      iconPlacement,
      onClick,
      hasBorder,
      noMargins,
      className,
      loading,
      disabled,
      pointer,
      fullWidth
    } = this.props;

    const { showIcon } = this.state;
    const resolvedIcon = loading ? <StyledSpinner spinnerColor={color} size={16} thickness={8} /> : icon;

    return (
      <StyledOpenButtonWrapper
        type="button"
        className={`toggle-button ${className}`}
        hasBorder={hasBorder}
        onClick={onClick}
        pointer={pointer}
        onMouseEnter={this.hoverHandler}
        onMouseLeave={this.hoverHandler}
        noMargins={noMargins}
        disabled={disabled}
        fullWidth={fullWidth}
      >
        {iconPlacement === 'before' && showIcon && <StyledSVGIcon>{resolvedIcon}</StyledSVGIcon>}
        <StyledButtonText iconPlacement={iconPlacement} className="button-text" color={color} tagName="span">
          {children}
        </StyledButtonText>
        {iconPlacement === 'after' && showIcon && <StyledSVGIcon>{resolvedIcon}</StyledSVGIcon>}
      </StyledOpenButtonWrapper>
    );
  }
}

export default TextLink;
